// extracted by mini-css-extract-plugin
export default {"myimage":"About_myimage__D5+H3","aboutme":"About_aboutme__xjwRR"};